import { withInstall } from '../../../utils/with-install'
import HawkEye from './HawkEye.vue'

export const ElAmapControlHawkEye = withInstall(HawkEye)
export default ElAmapControlHawkEye
